<template>
  <section class="app-article-detail">
    <GfrContainer>
      <h1 class="app-article-detail-title">{{ articleDetail?.title }}</h1>
      <article class="app-article-detail-content app-markdown-content" v-html="articleDetail?.content_html" />
    </GfrContainer>
  </section>
</template>
<script setup lang="ts">
const route = useRoute()
const { fetchArticleDetail } = useArticleStore()
const articleDetail = await fetchArticleDetail(Number(route.params.id))
</script>
<style lang="scss">
@import '@/assets/css/markdown-theme.scss';
</style>
<style lang="scss" scoped>
.app-article-detail {
  @apply pt-[3.875rem] pb-13 max-lg:pt-5 max-lg:pb-8;
}
.app-article-detail-title {
  @apply relative ltr:pl-3.5 rtl:pr-3.5 text-m-h2 font-bold max-lg:text-[22px] max-lg:leading-8;
  @apply before:absolute ltr:before:left-0 rtl:before:right-0 before:top-2 before:h-6 before:w-1.5 before:bg-primary before:content-[''];
  @apply max-lg:before:hidden max-lg:px-0;
}
</style>
